import { render, staticRenderFns } from "./SurveyReferensi.vue?vue&type=template&id=7a981ef2&scoped=true&lang=html&"
import script from "./SurveyReferensi.vue?vue&type=script&lang=js&"
export * from "./SurveyReferensi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a981ef2",
  null
  
)

export default component.exports